import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

export const PROFILES_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_PROFILES_MGMT,
  STEP_ONE: `${ROUTES.ADMIN_PROFILES_MGMT}`,
  ROLES_MANAGEMENT: `${ROUTES.ADMIN_PROFILES_MGMT}/rolesMgmt`,
  USER_ROLES_MANAGEMENT: `${ROUTES.ADMIN_PROFILES_MGMT}/userRolesMgmt`,
  USER_ROLES_MANAGEMENT_USER_DETAILS: `${ROUTES.ADMIN_PROFILES_MGMT}/userRolesMgmt/userDetails`,
  ROLE_USERS_MANAGEMENT: `${ROUTES.ADMIN_PROFILES_MGMT}/rolesMgmt/usersMgmt`,
};

export const STATE_IDENTIFIERS = {
  ROLES_MGMT: "rolesManagement",
  USER_ROLES_MGMT: "userRolesManagment",
  USERS_IDENTIFIER: "users",
  LOADER_IDENTIFIER: "loader",
  USER_DETAILS: "userDetails",
  SELECTABLE_ROLES: "selectableRoles",
  USER_ROLES: "userRoles",
  LIST_IDENTIFIER: "list",
  SELECTED_USER: "selectedUser",
  RESPONSE_STATE: "responseState",
  ADDED_ROLES: "addedRoles",
  DELETED_ROLES: "deletedRoles",
  ROLES_IDENTIFIER: "roles",
  VISIBILITY_CONES_IDENTIFIER: "visibilityCones",
  ROLE_USERS_MGMT: "roleUsersManagement",
  SELECTED_ROLE: "selectedRole",
  SELECTED_USERS: "selectedUsers",
  USERS_LOADER_IDENTIFIER: "usersLoader",
  SELECTED_USERS_LOADER_IDENTIFIER: "selectedUsersLoader",
  ROLE_TO_EDIT: "roleToEdit",
  VISIBILITY_CONE_TO_EDIT: "visibilityConeToEdit",
  FAILURES: "failures",
  SELECTED_USERS_CODES: "selectedUsersCodes",
  ROLES_NEW_VISIBILITY_CONE: "rolesNewVisibilityCone",
};

export interface IProfileMgmtUsers {
  id?: string;
  code?: string;
  name?: string;
  surname?: string;
  email?: string;
  organizational_unit_code?: string;
  organizational_unit?: string;
  resp_code?: string;
  company?: string;
  fullname?: string;
  identitySystemId?: string;
  ouDescription?: string;
  supervisor?: string;
  supervisorFullName?: string;
  userType?: string;
  type?: string;
  added?: boolean;
  deleted?: boolean;
}
export interface IFetchAllUsersBody extends IProfileMgmtUsers {
  pageNumber: number;
  pageSize: number;
}

export interface IFetchAllUsersResponse {
  pageNumber: number;
  totalElements: number;
  pageTotalNumber: number;
  pageSize: number;
  responsecode: number;
  responseStatus: string;
  users: IProfileMgmtUsers[];
}

export interface IUserRole {
  id?: number;
  idRole?: number;
  userCode?: string;
  role: string;
  added?: boolean;
  deleted?: boolean;
}

export interface IModifyRolesBody {
  code: string[];
  insertRoles: number[];
  deleteRoles: number[];
}

export interface IVisibilityCone {
  id: number;
  role: string;
  object: string;
  visibility?: string;
  insertDate?: string;
  updateDate?: string;
  consoleAdminProfilesManagementVisibility?: string;
}

export interface INewRoleModalProps {
  show: boolean;
  onClose: () => void;
  onSave: (roleName: string) => void;
  roleToModify: IUserRole;
}

export interface INewVisibilityConeModalProps {
  show: boolean;
  onClose: () => void;
  onSave: (role: string, visibilityCone: string, object: string) => void;
  visibilityConeToModify: IVisibilityCone;
  roles: IUserRole[];
}
